import React, { useState } from 'react'
import Success from '../../../../../../../Components/Success/Success'
import Batch from './Batch'
import { withStoreProvider } from '../../../../../../../Helpers/withStoreProvider'
import GroupRegistration from '../../GroupRegistration'
import GroupRegistrationStore from '../../GroupRegistration/Store/GroupRegistrationStore'

const EnrollmentBatches = ({ batches, enroll, name, teacher }) => {
  const [success, setSuccess] = useState(false)
  const { selBatch, setSelBatch } = GroupRegistrationStore.useContainer()

  return (
    <div className='enrollmentBatches'>
      {selBatch ? (
        <GroupRegistration
          onSubmit={async (message, id, videoURL) => {
            window.localStorage.setItem('auditionVideo', videoURL)
            const success = await enroll(message, id)
            if (success) {
              setSuccess(true)
            }
          }}
        />
      ) : (
        batches.map(({ dateSlots, title, id }, i) => (
          <Batch
            id={id}
            key={`existing-batch-${i}`}
            title={title}
            index={i}
            slots={dateSlots}
            enroll={enroll}
            setSuccess={setSuccess}
            setSelBatch={setSelBatch}
          />
        ))
      )}

      {success && (
        <Success
          heading={`Your enrollment request for the course ${name} has been sent to ${teacher}`}
          subText={`You will be notified when ${teacher} accepts your enrollment requests.`}
          secondary={{
            hidden: true,
          }}
          primary={{
            name: 'Go to home',
            route: '/',
          }}
        />
      )}
    </div>
  )
}

export default withStoreProvider([GroupRegistrationStore])(EnrollmentBatches)
